import {
  EConnectionStatus,
} from './rendering-engine-view.ts';

const connectionStatus: Record<EConnectionStatus, string> = {
  [EConnectionStatus.CONNECTING]: 'Stelle Verbindung her',
  [EConnectionStatus.CONNECTED]: 'Verbunden',
  [EConnectionStatus.WAITING_FOR_DATA]: 'Warte auf Daten',
  [EConnectionStatus.ERROR]: 'Fehler',
};

export default {
  connectionStatus,
  latestUpdate: 'Letzte Aktualisierung',
  enterFullscreen: 'Vollbild',
  exitFullscreen: 'Vollbildmodus beenden',
};
